import React from 'react';
import { Card } from '../ui/card';
import { Skeleton } from '../ui/skeleton';

const PostCardSkeleton: React.FC = () => (
    <Card variant="interactive" aria-hidden="true">
        <Skeleton className="aspect-[2/1] w-full rounded-none" />
        <div className="p-4 space-y-3">
            {/* Single-line title — matches PostCard's line-clamp-1 title so the skeleton
                isn't taller than the loaded card (avoids a layout shift on load). */}
            <Skeleton className="h-7 w-3/4" />
            {/* Excerpt — two lines, matching the card's line-clamp-2 min-h-[2lh]. */}
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <div className="flex items-center justify-between">
                {/* Bottom-left: "date · read time" cluster */}
                <Skeleton className="h-4 w-32" />
                {/* Bottom-right: category badge (pill) */}
                <Skeleton className="h-5 w-24 rounded-full" />
            </div>
        </div>
    </Card>
);

export default PostCardSkeleton;
